// extracted by mini-css-extract-plugin
module.exports = {"subheading":"index-module__subheading___iYhyB"};